export const assignStatusExternalOptions: { label: string; value: string }[] = [
  {
    label: "Application",
    value: "Application",
  },
  {
    label: "Assessment",
    value: "Assessment",
  },
  {
    label: "Finalised",
    value: "Finalised",
  },
];

export const assignStatusExternalSecondaryOptions: { [key: string]: { label: string; value: string }[] } = {
  Application: [
    {
      label: "Awaiting review",
      value: "Awaiting review",
    },
    {
      label: "Closed",
      value: "Closed",
    },
    {
      label: "Incomplete",
      value: "Incomplete",
    },
    {
      label: "Not submitted",
      value: "Not submitted",
    },
    {
      label: "On hold",
      value: "On hold",
    },
  ],
  Assessment: [
    {
      label: "Application awaiting review",
      value: "Application awaiting review",
    },
    {
      label: "Application in progress",
      value: "Application in progress",
    },
    {
      label: "Application incomplete",
      value: "Application incomplete",
    },
    {
      label: "Closed",
      value: "Closed",
    },
    {
      label: "In progress",
      value: "In progress",
    },
    {
      label: "On hold",
      value: "On hold",
    },
  ],
  Finalised: [
    {
      label: "Appeal received",
      value: "Appeal received",
    },
    {
      label: "Child transfer received",
      value: "Child transfer received",
    },
    {
      label: "Outcome sent",
      value: "Outcome sent",
    },
    {
      label: "Withdrawn",
      value: "Withdrawn",
    },
  ],
};
